
import { useState, useEffect } from 'react';
import { PaymentType } from '@/types/payment';
import { PaginationState } from './types';

export const usePagination = (items: PaymentType[], pageSize: number = 5) => {
  const [page, setPage] = useState(1);
  const [paginatedItems, setPaginatedItems] = useState<PaymentType[]>([]);
  
  useEffect(() => {
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    setPaginatedItems(items.slice(startIndex, endIndex));
  }, [items, page, pageSize]);
  
  const pagination: PaginationState = {
    page,
    pageSize,
    totalPages: Math.ceil(items.length / pageSize)
  };
  
  return {
    paginatedItems,
    pagination,
    setPage
  };
};
